import {
  SET_USERS,
  SET_DASHBOARD_FILTER,
  SET_DASHBOARD_TARGET_FILTER,
  SET_DATASETS,
  SET_PRIMARY_INSIGHTS_FILTER,
  SET_BYOD_DATASET,
  SET_DATASET_FAMILIES,
  SET_DAY_PARTS,
  SET_QUICK_ADD_ATTRIBUTES,
  SET_DATE_RANGE,
} from './constants'

const mutations = {
  [SET_DATASETS](state, datasets) {
    state.datasets = datasets
  },
  [SET_PRIMARY_INSIGHTS_FILTER](state, primaryInsightsFilter) {
    state.primaryInsightsFilter = primaryInsightsFilter
  },
  [SET_BYOD_DATASET](state, dataset) {
    state.byodDataset = dataset
  },
  [SET_DATASET_FAMILIES](state, families) {
    console.log(families)
    state.datasetFamilies = families
  },
  [SET_USERS](state, users) {
    state.users = users
  },
  [SET_DASHBOARD_FILTER](state, filter) {
    state.filter = filter
  },
  [SET_DAY_PARTS](state, dayParts) {
    state.dayParts = dayParts
  },
  [SET_DASHBOARD_TARGET_FILTER](state, value) {
    state.targetFilter = value
  },
  [SET_QUICK_ADD_ATTRIBUTES](state, value) {
    state.quickAddAttributes = value
  },
  [SET_DATE_RANGE](state, value) {
    const { dateRanges, mriLatestMonth, ncsLatestMonth } = value
    const mriIdx = dateRanges.findIndex(d => d.name === mriLatestMonth)
    const ncsIdx = dateRanges.findIndex(d => d.name === ncsLatestMonth)

    state.dateRanges = dateRanges

    state.maxEndMonths.amrld = dateRanges[dateRanges.length - 1]
    state.maxEndMonths.mri = dateRanges[mriIdx]
    state.maxEndMonths.ncs = dateRanges[ncsIdx]
    state.minStartMonths.amrld = dateRanges[dateRanges.length - 12]
    state.minStartMonths.mri = dateRanges[mriIdx - 11]
    state.minStartMonths.ncs = dateRanges[ncsIdx - 11]
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/store/modules/applicationResources/mutations.js